(function () {
    'use strict';

    angular
        .module('app')
        .controller('EntityEditCtrl', EntityEditCtrl);

    EntityEditCtrl.$inject = ['$scope', '$injector'];

    /**
     * @ngdoc controller
     * @name EntityEditCtrl
     * 
     * @description
     * For editing an existing entity or creating a new one.
     */
    function EntityEditCtrl($scope, $injector) {
        $injector.invoke(EntityEditCtrlBase, this, { $scope: $scope, userProfileMode: false });
    }


    angular
        .module('app')
        .controller('UserProfileEditCtrl', UserProfileEditCtrl);

    UserProfileEditCtrl.$inject = ['$scope', '$injector'];

    /**
     * @ngdoc controller
     * @name UserProfileEditCtrl
     * 
     * @description
     * For editing the users own profile.
     */
    function UserProfileEditCtrl($scope, $injector) {
        $injector.invoke(EntityEditCtrlBase, this, { $scope: $scope, userProfileMode: true });
    }


    angular
        .module('app')
        .controller('EntityEditCtrlBase', EntityEditCtrlBase);

    EntityEditCtrlBase.$inject = [
        '$scope',
        '$routeParams',
        '$location',
        '$q',
        '$timeout',
        'EntitiesService',
        'EntityTemplatesService',
        'FieldTypesService',
        'FileSelectorService',
        'ActivityPermissionService',
        'DialogService',
        'NavigationAidService',
        'DocMergeService',
        'UnsavedChangesService',
        'WorkflowRunService',
        'Entity',
        'EntityFieldImage',
        'ChilliUserProfileService',
        'SystemService',
        'SecurityService',
        'ObjectSaveErrorHandlerService',
        'WindowTitleService',
        'LastUpdatedService',
        'ItemService',
        'TasksService',
        'HistoryService',
        'userProfileMode'];

    /**
     * @ngdoc controller
     * @name EntityEditCtrlBase
     * 
     * @description
     * For editing an existing entity or creating a new one.
     * Instead of using this controller directly, use one of its "containing" controllers: EntityEditCtrl, UserProfileEditCtrl.
     */
    function EntityEditCtrlBase(
        $scope,
        $routeParams,
        $location,
        $q,
        $timeout,
        EntitiesService,
        EntityTemplatesService,
        FieldTypesService,
        FileSelectorService,
        ActivityPermissionService,
        DialogService,
        NavigationAidService,
        DocMergeService,
        UnsavedChangesService,
        WorkflowRunService,
        Entity,
        EntityFieldImage,
        ChilliUserProfileService,
        SystemService,
        SecurityService,
        ObjectSaveErrorHandlerService,
        WindowTitleService,
        LastUpdatedService,
        ItemService,
        TasksService,
        HistoryService,
        userProfileMode) {

        /* jshint validthis:true */
        var vm = this;

        vm.entity = null;
        vm.userACL = []; // Applicable only if the entity has an EntityType of 'User'.
        Object.defineProperty(vm, 'entityModels', { get: function () { return { Entity: vm.entity, ACL: vm.userACL }; } });
        vm.userProfile = null;

        vm.entityTemplates = [];
        vm.fieldTypes = [];
        vm.activityPermissions = [];
        vm.currentTabPage = 'details';

        // The files from here will be attached to the multipart form when the entity is saved.
        // This is used by contained directives, do not delete it without careful analysis.
        vm.fileAttachmentList = {};

        vm.itemListApi = {};
        vm.historyListApi = {};
        vm.itemCount = 0;
        vm.taskCount = 0;
        vm.historyCount = 0;
        vm.saveEntity = saveEntity;
        vm.deleteEntity = deleteEntity;
        vm.mergeDocument = mergeDocument;
        vm.composeEmail = composeEmail;
        vm.composeSMS = composeSMS;
        vm.addTask = addTask;
        vm.addNote = addNote;
        vm.addFile = addFile;
        vm.runWorkflow = runWorkflow;
        vm.copyEntity = copyEntity;
        vm.exportEntity = exportEntity;
        vm.importEntities = importEntities;
        vm.showTab = showTab;
        vm.close = close;
        vm.loadItemCount = loadItemCount;
        vm.loadTaskCount = loadTaskCount;
        vm.loadHistoryCount = loadHistoryCount;
        Object.defineProperty(vm, 'lastUpdatedLabel', { get: function () { return LastUpdatedService.getLabel(vm.entity); } });
        Object.defineProperty(vm, 'entityIsNew', { get: getEntityIsNew });
        Object.defineProperty(vm, 'entityId', { get: getEntityId });
        vm.viewTitle = '';
        Object.defineProperty(vm, 'dirty', {
            get: function () { return !_.isNil(UnsavedChangesService) && UnsavedChangesService.dirty; }
        });
        Object.defineProperty(vm, 'userIsAdministrator', {
            get: function () { return ChilliUserProfileService.userIsAdministrator; }
        });
        vm.entityLimitReached = false;
        vm.entityNotFound = false;
        vm.loading = true;
        vm.permissionDenied = false;
        vm.saveInProgress = false;

        activate();

        var loadEntityTemplatesPromise;
        var loadUserProfilePromise;

        function activate() {
            updateViewTitle();

            var userIsAdmin = false;
            var verifyUserIsAdminErrorResponse = null;
            var verifyUserIsAdminPromise = ChilliUserProfileService.verifyUserIsAdministrator({
                onUserIsAdmin: function () { userIsAdmin = true; },
                onError: function (response) { verifyUserIsAdminErrorResponse = response; }
            });

            loadUserProfilePromise = loadUserProfile();

            loadEntityTemplatesPromise = loadEntityTemplates();

            NavigationAidService.watchTabPage($scope, 'vm.currentTabPage');

            var loadPromises = [];
            loadPromises.push(loadEntityTemplatesPromise);
            loadPromises.push(loadFieldTypes());
            loadPromises.push(loadActivityPermissions());
            loadPromises.push(loadEntity());
            loadPromises.push(verifyUserIsAdminPromise);

            $q.all(loadPromises).then(function () {
                vm.loading = false;

                updateViewTitle();

                var currentTabFromHistory = NavigationAidService.getCurrentTabPage();
                if (!_.isNil(currentTabFromHistory)) {
                    // Load tab page from history
                    if (vm.showTab(currentTabFromHistory)) {
                        vm.currentTabPage = currentTabFromHistory;
                    }
                }

                var entityTemplateName = '';
                if (!_.isNil(vm.entity) && !_.isNil(vm.entity.EntityTemplate)) {
                    entityTemplateName = vm.entity.EntityTemplate.Name;
                }

                if (!userProfileMode && !_.isNil(vm.entity) && !_.isNil(vm.entity.EntityTemplate) && !_.isNil(vm.entity.EntityTemplate.EntityType)) {
                    if (SystemService.getEntityTypesRequiringAdminAccess().indexOf(vm.entity.EntityTemplate.EntityType) != -1 && !userIsAdmin) {

                        if (vm.entity.Id === vm.userProfile.Id) {
                            userProfileMode = true;
                        } else {
                            vm.permissionDenied = true;
                        }
                    }
                }

                if (!vm.entityNotFound && !vm.permissionDenied) {
                    // Set any invalid fields to be touched, so their invalid status will be obvious to the user.
                    $timeout(function () {

                        // We check for presence of all aspects of the form because this is in a
                        // $timeout. It's possible it will be executing after the form has been destroyed.
                        // E.g. user clicks back and forward button quickly.

                        if (vm && vm.addEntityForm && vm.addEntityForm.$invalid) {
                            angular.forEach(vm.addEntityForm.$error, function (field) {
                                angular.forEach(field, function (errorField) {
                                    if (!_.isNil(errorField.field)) {
                                        errorField.field.$setTouched();
                                    }
                                });
                            });
                        }
                    });

                    UnsavedChangesService.register({
                        scope: $scope,
                        modelExpression: 'vm.entityModels',
                        saveFunction: saveEntity,
                        unsavedItemName: entityTemplateName
                    });

                    if (!_.isNil($routeParams.copyEntityId)) {
                        UnsavedChangesService.dirty = true;
                    }
                }
            });
        }

        /**
         * Load total item count.
         */
        function loadItemCount() {
            if (!vm.entityIsNew && vm.entityId) {
                ItemService.getItemsByParent(vm.entityId, {
                    pageNumber: 1,
                    pageSize: 0,
                    // Note that the list should match all record types in item-list.directive.js drvCtrl.recordTypes
                    recordType: ['Email', 'File', 'Note', 'SMS'],
                    excludeLinkTypes: ['Entity Image']
                }).then(getItemCountOk);
            }

            function getItemCountOk(data) {
                vm.itemCount = data.ItemCount;
            }
        }

        /**
         * Load total task count.
         */
        function loadTaskCount() {
            if (!vm.entityIsNew && vm.entityId) {
                TasksService.query({
                    currentPage: 1,
                    pageSize: 0,
                    LinkedEntityId: vm.entityId
                }).then(getTaskCountOk);
            }

            function getTaskCountOk(data) {
                vm.taskCount = data.TaskCount;
            }
        }

        /**
         * Load total history count.
         */
        function loadHistoryCount() {
            if (!vm.entityIsNew && vm.entityId) {
                HistoryService.getHistoryForItem({
                    masterRecordId: vm.entityId,
                    pageNumber: 1,
                    pageSize: 0
                }).then(getHistoryCountOk);
            }

            function getHistoryCountOk(data) {
                vm.historyCount = data.ItemCount;
            }
        }

        /**
         * Load the profile for the logged in user, i.e. the user entity.
         * Sets vm.userProfile once loaded, displays a dialog if there was a loading error.
         *
         * @returns {promise} A promise that resolves with an {object} of the user profile entity.
         */
        function loadUserProfile() {
            return ChilliUserProfileService.getUserProfile(true)
                .then(loadProfileOk, loadProfileError);

            function loadProfileOk(data) {
                vm.userProfile = data;
                return data;
            }

            function loadProfileError(response) {
                DialogService.error('Error loading User profile', response);
            }
        }

        /**
         * Determine if tab option should be shown.
         *
         * @param {string} tabName - Name of the tab e.g. 'details', 'settings', 'tasks'.
         * @returns {bool} Should the tab be shown.
         */
        function showTab(tabName) {
            if (tabName === 'details') {
                // Always show details tab
                return true;
            }

            if (vm.loading || vm.entityNotFound || vm.permissionDenied) {
                // Only show other tabs if the entity is found, and fully loaded
                return false;
            }

            if (tabName === 'security') {
                // Only show security tab if the entity is a 'User' and the logged in user is admin
                return vm.entity.EntityTemplate.EntityType === 'User' && vm.userIsAdministrator;
            }

            if (vm.entityIsNew) {
                // Other tabs only show if this is NOT a new entity
                return false;
            }

            // If none of the above criteria were met, show the tab
            return true;
        }

        /**
         * Update Title to be shown at the top of the view and browser window/tab title.
         */
        function updateViewTitle() {
            var title = '';

            if (vm.entityIsNew) {
                title += 'Add ';
            }

            if (!_.isNil(vm.entity)) {
                if (!_.isNil(vm.entity.EntityTemplate)) {
                    title += vm.entity.EntityTemplate.Name;
                }

                if (!_.isNil(vm.entity.PreviewNameText) && vm.entity.PreviewNameText !== '' && !vm.permissionDenied && !vm.loading) {
                    title += ' - ' + vm.entity.PreviewNameText;
                }
            }
            
            vm.viewTitle = title;
            WindowTitleService.setTitle(title);
        }

        /**
         * Determine if this is a new entity.
         *
         * @returns {bool} True if this is a new entity, False is this is an existing entity.
         */
        function getEntityIsNew() {
            if ($routeParams.id && $routeParams.id === 'new') {
                return true;
            } else {
                return false;
            }
        }

        /**
         * Get the id of the current entity. If the entity has not yet been loaded, route params will be used otherwise the loaded
         * entity details will be used.
         *
         * @returns {number} Entity id if the entity has been persisted. Otherwise undefined will be returned.
         */
        function getEntityId() {
            var result;

            if (!vm.entityIsNew) {
                if (!_.isNil(vm.entity) && vm.entity.Id !== 'new') {
                    result = vm.entity.Id;
                } else if ($routeParams.id) {
                    result = $routeParams.id;
                }
            }

            return result;
        }

        /**
         * Load the entity to the viewmodel, be it a new entity or an existing one.
         *
         * @returns {promise} A promise that resolves once the entity is loaded.
         */
        function loadEntity() {
            var loadPromise;

            if (userProfileMode) {
                loadPromise = loadUserProfilePromise;
            } else if (!vm.entityIsNew && vm.entityId) {
                loadPromise = EntitiesService.get(vm.entityId);
            } else if (!_.isNil($routeParams.copyEntityId)) {
                loadPromise = newEntityCopy();
            } else if (!_.isNil($routeParams.entityTemplateId)) {
                loadPromise = newEntity();
            } else {
                loadPromise = $q.when(null);
            }

            return loadPromise.then(getEntityOk, getEntityError);

            function getEntityOk(data) {
                if (angular.isDefined(data) && data !== null) {
                    vm.entity = data;

                    // Set any undefined fields on the entity to null
                    if (!_.isNil(vm.entity.EntityTemplate) && !_.isNil(vm.entity.EntityTemplate.Fields)) {
                        angular.forEach(vm.entity.EntityTemplate.Fields, function (templateField) {
                            if (angular.isUndefined(vm.entity.Fields[templateField.Name])) {
                                vm.entity.Fields[templateField.Name] = null;
                            }
                        });
                    }

                    var extraLoadingPromises = [];

                    // If the entity is a 'User', load the ACL for that user
                    if (!_.isNil(vm.entity.EntityTemplate) && vm.entity.EntityTemplate.EntityType === 'User') {
                        extraLoadingPromises.push(loadUserAcl());
                    }

                    return $q.all(extraLoadingPromises);

                } else {
                    vm.entityNotFound = true;
                }
            }

            function getEntityError(response) {
                if (response.status === 404) {
                    vm.entityNotFound = true;
                } else {
                    DialogService.error('Error fetching Entity', response);
                }
            }
        }

        /**
         * Creates a new entity, pre-populating details from the route-specified entity copy source.
         *
         * @returns {promise} A promise that resolves the new entity.
         */
        function newEntityCopy() {
            return Entity.get($routeParams.copyEntityId)
                    .then(function loadCopyOk(entityObj) {

                        // Remove all images
                        var iter = entityObj.getFieldIterator();
                        while (iter.next()) {
                            if (iter.currentEntityField instanceof EntityFieldImage) {
                                iter.currentEntityField.value = null;
                            }
                        }

                        // Reset properties specific to existing entity
                        entityObj.Id = null;
                        entityObj.PreviewNameText = '';
                        entityObj.PreviewDescriptionText = '';
                        entityObj.EmailAddress = '';
                        
                        // Load the entities count if maximum entities has been set, so it can be checked if a new entity is allowed
                        if (!_.isNil(entityObj.EntityTemplate.MaximumEntities) && entityObj.EntityTemplate.MaximumEntities !== '') {
                            return EntityTemplatesService.getEntityCount(entityObj.EntityTemplate.Id, false).then(function getEntitiesCountOk(entitiesCount) {
                                if (entitiesCount >= entityObj.EntityTemplate.MaximumEntities)
                                    vm.entityLimitReached = true;

                                return entityObj.toValueObject();
                            });
                        } else {
                            return entityObj.toValueObject();
                        }
                    });
        }

        /**
         * Creates a new entity, taking into consideration any specification of an entity template in the URL.
         *
         * @returns {promise} A promise that resolves the new entity.
         */
        function newEntity() {
            var entity = {
                Fields: {}
            };

            if (angular.isDefined($routeParams.entityTemplateId) && $routeParams.entityTemplateId !== null) {
                // Set entity template according to template ID specified in URL
                return loadEntityTemplatesPromise.then(function loadEntityTemplatesOk() {
                    var entityTemplate = null;

                    if (angular.isDefined(vm.entityTemplates)) {
                        entityTemplate = _.find(vm.entityTemplates, function (entityTemplate) {
                            return entityTemplate.Id.toString() === $routeParams.entityTemplateId;
                        });
                    }

                    if (!_.isNil(entityTemplate)) {
                        if (!entityTemplate.UserGranted) {
                            vm.permissionDenied = true;
                            return null;
                        } else {
                            entity.EntityTemplate = angular.copy(entityTemplate);
                            entity.Fields = EntityTemplatesService.getDefaultEntityFields(vm.entityTemplates, $routeParams.entityTemplateId);

                            // Load the entities count if maximum entities has been set, so it can be checked if a new entity is allowed
                            if (!_.isNil(entityTemplate.MaximumEntities) && entityTemplate.MaximumEntities !== '') {
                                return EntityTemplatesService.getEntityCount(entityTemplate.Id, false).then(function getEntitiesCountOk(entitiesCount) {
                                    if (entitiesCount >= entityTemplate.MaximumEntities)
                                        vm.entityLimitReached = true;

                                    return entity;
                                });
                            } else {
                                return entity;
                            }
                        }
                    } else {
                        return null;
                    }
                });
            } else {
                return $q.when(entity);
            }
        }

        /**
         * Load all entity templates to the viewmodel.
         *
         * @returns {promise} A promise that resolves once entity templates are loaded.
         */
        function loadEntityTemplates() {
            return EntityTemplatesService.query({ AllowDeleted: true })
                .then(getEntityTemplatesOk, getEntityTemplatesError);

            function getEntityTemplatesOk(data) {
                _.remove(data.EntityTemplates, function (entityTemplate) { return entityTemplate.Active === false; });
                vm.entityTemplates = _.sortBy(data.EntityTemplates, function (entityTemplate) { return entityTemplate.Name; });
            }

            function getEntityTemplatesError(response) {
                DialogService.error('Error fetching Entity Templates', response);
            }
        }

        /**
         * Load all field types to the viewmodel.
         *
         * @returns {promise} A promise that resolves once field types are loaded.
         */
        function loadFieldTypes() {
            return FieldTypesService.getFieldTypes()
                .then(getFieldTypesOk, getFieldTypesError);

            function getFieldTypesOk(data) {
                vm.fieldTypes = data;
            }

            function getFieldTypesError(response) {
                DialogService.error('Error fetching field types', response);
            }
        }

        /**
         * If the entity is a 'User' type, they will have an entity template ACL.
         * I.e. a list of entity templates they do / do not have access to.
         *
         * @returns {promise} A promise that resolves once the user ACL is loaded.
         */
        function loadUserAcl() {
            var getAcl;
            if (!vm.entityIsNew) {
                getAcl = SecurityService.getEntityTemplateAcl(vm.entityId);
            } else {
                getAcl = SecurityService.getEntityTemplateAcl();
            }

            return getAcl.then(ok, error);

            function ok(aclData) {
                vm.userACL = aclData;
            }

            function error(response) {
                DialogService.error('Error fetching security details for User', response);
            }
        }

        /**
         * Load activity permissions to the view model.
         * Activity permissions are things like "Edit Entity Templates" and "Edit Document Templates".
         *
         * @returns {promise} A promise that resolves once activity permissions are loaded.
         */
        function loadActivityPermissions() {
            return ActivityPermissionService.getActivityPermissions()
                .then(getActivityPermissionsOk, getActivityPermissionsError);

            function getActivityPermissionsOk(data) {
                vm.activityPermissions = data;
            }

            function getActivityPermissionsError(response) {
                DialogService.error('Error fetching Activity permissions', response);
            }
        }

        /**
         * Save the entity. Displays a dialog if there was an error saving the entity.
         *
         * @return {promise} Resolves if the entity was saved, rejected if there was an error.
         */
        function saveEntity() {
            vm.saveInProgress = true;

            if (!_.isNil(vm.addEntityForm) && vm.addEntityForm.$invalid) {
                vm.saveInProgress = false;

                var templateName = 'entity';
                if (!angular.isUndefined(vm.entity.EntityTemplate) && vm.entity.EntityTemplate !== null && !angular.isUndefined(vm.entity.EntityTemplate.Name) && vm.entity.EntityTemplate.Name !== null && vm.entity.EntityTemplate.Name !== '') {
                    templateName = vm.entity.EntityTemplate.Name;
                }

                return DialogService.messageList('Error saving ' + templateName, null, vm.addEntityForm.$error)
                    .then(function () {
                        return $q.reject();
                    });
            } else {
                saveEntity.savePromise = EntitiesService.save(vm.entity, vm.fileAttachmentList)
                    .then(saveEntityOk, saveEntityError)
                    .finally(function () { vm.saveInProgress = false; });

                return saveEntity.savePromise;
            }

            var thisEntityId;

            function saveEntityOk(savedEntity) {
                thisEntityId = savedEntity.Id;
                vm.entity = savedEntity;

                updateViewTitle();

                if (vm.entity.EntityTemplate.EntityType === 'User' && vm.userIsAdministrator) {
                    return SecurityService.updateUserEntityTemplateAcl(thisEntityId, vm.userACL)
                        .then(saveEntityFinish, saveUserAclError);
                } else {
                    saveEntityFinish();
                }
            }

            function saveEntityError(response) {
                return ObjectSaveErrorHandlerService.handleObjectSaveError(
                    response,
                    vm.entity,
                    vm.entity.EntityTemplate.Name,
                    vm.saveEntity,
                    function () {
                        return EntitiesService.get(vm.entityId);
                    });
            }

            function saveUserAclError(response) {
                return DialogService.error('Error saving User security, please try again', response)
                    .then(saveEntityFinish);
            }

            function saveEntityFinish() {
                UnsavedChangesService.register({
                    scope: $scope,
                    modelExpression: 'vm.entityModels',
                    saveFunction: saveEntity,
                    unsavedItemName: vm.entity.EntityTemplate.Name
                });

                if (vm.entityIsNew) {
                    NavigationAidService.replacePage('entities/' + thisEntityId);
                } else {
                    vm.historyListApi.refresh();
                    vm.addEntityForm.$setPristine();
                }
            }
        }

        /**
         * Delete the entity.
         */
        function deleteEntity() {
            var templateName = 'Entity';
            if (!angular.isUndefined(vm.entity.EntityTemplate) && vm.entity.EntityTemplate !== null && !angular.isUndefined(vm.entity.EntityTemplate.Name) && vm.entity.EntityTemplate.Name !== null && vm.entity.EntityTemplate.Name !== '') {
                templateName = vm.entity.EntityTemplate.Name;
            }

            if (!vm.entityIsNew) {
                DialogService.confirm('Delete the ' + templateName + '?', 'Entity delete confirm')
                    .then(deleteOk);
            } else {
                promptUserToSaveForOperation('deleting');
            }

            function deleteOk() {
                EntitiesService.remove(vm.entityId)
                    .then(deleteEntityOk, deleteEntityError);
                    
                function deleteEntityOk(success) {
                    NavigationAidService.goBack();
                }

                function deleteEntityError(response) {
                    DialogService.error('Error deleting Entity', response);
                }
            }
        }


        /**
         * Merge a document template, using the current entity as data source.
         * Will prompt user for input/decisions as necessary.
         */
        function mergeDocument() {
            if (_.isNil(vm.entity.Id) || vm.entityId === '') {
                promptUserToSaveForOperation('merging');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges(vm.entity.EntityTemplate.Name)
                        .then(SaveEntityPromptOk);
                } else {
                    mergeProcess();
                }
            }

            function SaveEntityPromptOk() {
                saveEntity().then(mergeProcess);
            }

            function mergeProcess() {
                DialogService.show({
                    locals: { entityTemplateId: vm.entity.EntityTemplate.Id, entityId: vm.entity.Id, entityTemplateName: vm.entity.EntityTemplate.Name },
                    controller: 'DocumentMergeCtrl',
                    controllerAs: 'vm',
                    templateUrl: 'app/documentmerge/document-merge.tmpl.html'
                })
                .then(getMergeDetailsOk);

                function getMergeDetailsOk(mergeDetails) {
                    DocMergeService.merge(vm.entity.Id, mergeDetails.DocumentTemplateId, mergeDetails.OutputFormat, mergeDetails.Description,
                        mergeDetails.FileDescription, mergeDetails.FileName, mergeDetails.Tags, mergeDetails.SaveToCurrentEntity,
                        mergeDetails.SaveToCurrentUser, mergeDetails.SaveToOrganisation, mergeDetails.SaveToEntities)
                        .then(mergeEntityDocumentTemplateOk, mergeEntityDocumentTemplateError);
                }

                function mergeEntityDocumentTemplateOk(data) {
                    vm.itemListApi.refresh();
                }

                function mergeEntityDocumentTemplateError(response) {
                    DialogService.error('Error merging Document', response);
                }
            }
        }

        /**
         * Redirects to the compose email route
         */
        function composeEmail() {
            if (_.isNil(vm.entity.Id) || vm.entityId === '') {
                promptUserToSaveForOperation('creating email');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges(vm.entity.EntityTemplate.Name)
                        .then(function () {
                            saveEntity().then(function () {
                                $location.url('email/new?fromEntityIds=' + vm.entity.Id);
                            });
                        });
                } else {
                    $location.url('email/new?fromEntityIds=' + vm.entity.Id);
                }
            }
        }

        /**
         * Redirects to the compose SMS route
         */
        function composeSMS() {
            if (_.isNil(vm.entity.Id) || vm.entityId === '') {
                promptUserToSaveForOperation('creating SMS');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges(vm.entity.EntityTemplate.Name)
                        .then(function () {
                            saveEntity().then(function () {
                                $location.url('sms?fromEntityIds=' + vm.entity.Id);
                            });
                        });
                } else {
                    $location.url('sms?fromEntityIds=' + vm.entity.Id);
                }
            }
        }

        /**
         * Redirects to the add Task route
         */
        function addTask() {
            if (_.isNil(vm.entity.Id) || vm.entityId === '') {
                promptUserToSaveForOperation('adding task');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges(vm.entity.EntityTemplate.Name)
                        .then(function () {
                            saveEntity().then(function () {
                                $location.url('tasks/new?entityId=' + vm.entity.Id);
                            });
                        });
                } else {
                    $location.url('tasks/new?entityId=' + vm.entity.Id);
                }
            }
        }

        /**
         * Redirects to the add Note route
         */
        function addNote() {
            if (_.isNil(vm.entity.Id) || vm.entityId === '') {
                promptUserToSaveForOperation('adding note');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges(vm.entity.EntityTemplate.Name)
                        .then(function () {
                            saveEntity().then(function () {
                                $location.url('notes/new?relatedItemId=' + vm.entity.Id);
                            });
                        });
                } else {
                    $location.url('notes/new?relatedItemId=' + vm.entity.Id);
                }
            }
        }
        
        /**
         * Redirects to the add File route
         */
        function addFile() {
            if (_.isNil(vm.entity.Id) || vm.entityId === '') {
                promptUserToSaveForOperation('adding file');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges(vm.entity.EntityTemplate.Name)
                        .then(function () {
                            saveEntity().then(function () {
                                $location.url('files/new?relatedItemId=' + vm.entity.Id);
                            });
                        });
                } else {
                    $location.url('files/new?relatedItemId=' + vm.entity.Id);
                }
            }
        }

        function runWorkflow() {
            if (_.isNil(vm.entity.Id) || vm.entityId === '') {
                promptUserToSaveForOperation('running workflow');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges(vm.entity.EntityTemplate.Name)
                        .then(function () {
                            saveEntity().then(function () {
                                WorkflowRunService.promptWorkflowStart(vm.entity.Id);
                            });
                        });
                } else {
                    WorkflowRunService.promptWorkflowStart(vm.entity.Id);
                }  
            }
        }

        /**
         * Redirects the user to a view with a copy of the current entity.
         */
        function copyEntity() {
            if (_.isNil(vm.entity.Id) || vm.entityId === '') {
                promptUserToSaveForOperation('copying');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges(vm.entity.EntityTemplate.Name)
                        .then(function () {
                            saveEntity().then(function () {
                                $location.url('entities/new?copyEntityId=' + vm.entity.Id);
                            });
                        });
                } else {
                    $location.url('entities/new?copyEntityId=' + vm.entity.Id);
                }
            }
        }

        /*
         * Export the entity to a spreadsheet file
         */
        function exportEntity() {
            if (_.isNil(vm.entity.Id) || vm.entityId === '') {
                promptUserToSaveForOperation('exporting');
            } else {
                if (UnsavedChangesService.dirty) {
                    DialogService.unsavedChanges(vm.entity.EntityTemplate.Name)
                        .then(function () {
                            saveEntity().then(function () {
                                exportEntityProcess();
                            });
                        });
                } else {
                    exportEntityProcess();
                }
            }

            function exportEntityProcess() {
                DialogService.show({
                    locals: {
                        entityTemplate: vm.entity.EntityTemplate,
                        entityCount: null,
                        entityPreviewName: vm.entity.PreviewNameText,
                        disableAllEntities: false
                            },
                    controller: 'ExportEntityDialogCtrl',
                    controllerAs: 'vm',
                    templateUrl: 'app/entity/export-entity-dialog.tmpl.html'
                }).then(exportEntitiesConfirmed);
            }

            function exportEntitiesConfirmed(exportDetails) {
                var entityIds = null;
                var entityTemplateId = null;
                var blankTemplate = null;

                switch (exportDetails.ExportType) {
                    case 'allEntities':
                        entityTemplateId = vm.entity.EntityTemplate.Id;
                        break;
                    case 'blankTemplate':
                        entityTemplateId = vm.entity.EntityTemplate.Id;
                        blankTemplate = true;
                        break;
                    case 'currentSelection':
                        entityIds = [vm.entity.Id];
                        break;
                }

                EntitiesService.exportEntities(entityIds, entityTemplateId, blankTemplate, exportDetails.IncludeLookups, exportDetails.Transpose, exportDetails.FieldsToExport)
                    .then(exportOk, exportError);
            }

            function exportOk(response) {
                var blob = new Blob([response.data], { type: response.headers('Content-Type') });
                var fileName = response.headers('Content-Disposition').match(/filename[^;\n=]*=((['"]).*?\2|[^;\n]*)/)[1];
                fileName = fileName.replace(/^"/, '');
                fileName = fileName.replace(/"$/, '');
                saveAs(blob, fileName);
            }

            function exportError(response) {
                DialogService.error('Error exporting ' + vm.entity.EntityTemplate.Name, response);
            }
        }

        /*
         * Import the entities from the selected file.
         */
        function importEntities() {
            FileSelectorService.selectLocalFileDialog(false, ['xlsx', 'xlsm'])
                .then(function (fileList) {
                    DialogService.show({
                        locals: {
                            entityTemplate: vm.entity.EntityTemplate,
                            file: fileList[0]
                        },
                        controller: 'ImportEntityDialogCtrl',
                        controllerAs: 'vm',
                        templateUrl: 'app/entity/import-entity-dialog.tmpl.html'
                    }).then(function (success) {
                        if (success) {
                            vm.loading = true;
                            loadEntity().finally(function () {
                                vm.loading = false;
                            });
                        }
                    });
                });
        }

        /*
         * When conducting an operation which requires a saved entity and the entity is new, a 'save entity' prompt needs to be shown
         *
         * @param {string} operationName - Name of operation that was being conducted
         */
        function promptUserToSaveForOperation(operationName) {
            return DialogService.show({
                controller: 'SaveItemDialogCtrl',
                controllerAs: 'vm',
                templateUrl: 'app/controls/dialog/save-item-dialog.tmpl.html',
                locals: { name: vm.entity.EntityTemplate.Name, operation: operationName }
            })
            .then(function () {
                return saveEntity();
            });
        }

        /**
         * When the view is 'closed' navigation to a previous page should occur.
         */
        function close() {
            NavigationAidService.goBack();
        }
    }
})();
